import PropTypes from 'prop-types';
import React from 'react';

import { MoreSpan, TagText } from './styles';
import messages from './Messages';
import { display } from 'components/ErrorView/ErrorDialog';
import ActionLink from 'components/ActionLink';
import Dropdown from 'components/Dropdown';
import Icon from 'components/Icon';
import TagEditor from './TagEditor';
import {
  createATag,
  removeTag,
  updateExistedTag,
  updateTag,
} from 'store/providers/providerSlice';
import i18n, { rightLanguageList } from '../../i18n';
import { lightGray } from 'utils/style/colors';

const { Menu, MenuItem, MenuDivider } = Dropdown;

class TagView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rename: false,
      showDropdown: false,
    };

    this.handleCancelSubmitTag = this.handleCancelSubmitTag.bind(this);
    this.handleSubmitTag = this.handleSubmitTag.bind(this);
  }

  onOpenFunction(item) {
    return () => {
      const listIndex = this.props.listIndex;
      this.props.onOpenItem(listIndex + 1, item.id);
    };
  }

  getMenuActions(item) {
    const menu = [
      {
        messages: messages.rename,
        callBack: () => {
          this.setState({ rename: true });
        },
        order: 1,
      },
      /*{
        messages: messages.move,
        callBack: () => {
          this.props.onMoveItem();
        },
        order: 2,
      },*/
    ];
    if (item.deleted) {
      menu.push({
        messages: messages.restore,
        callBack: () => {
          this.props.onRestoreItem();
          return true;
        },
        order: 3,
      });
    } else {
      menu.push({
        messages: messages.delete,
        callBack: () => {
          if (window.confirm(messages.confirmDelete)) {
            this.props.onDeleteItem();
          }
          return true;
        },
        order: 3,
      });
    }
    return menu;
  }

  handleSubmitTag(mode, title, exists, titles, type, order) {
    const tag = this.props.item;
    if (mode === 'update') {
      // rename a tag
      const clonedTag = { ...this.props.item };
      clonedTag.text = title;
      clonedTag.type = type;
      clonedTag.order = order || clonedTag.order;
      if (clonedTag.text.length > 0) {
        this.props
          .dispatch(
            updateTag({ tag: clonedTag, providerId: this.props.providerId })
          )
          .then(
            () => {
              this.setState({ rename: false });
            },
            (err) => {
              display(err);
            }
          );
      }
    } else if (mode === 'create') {
      if (exists) {
        // move a tag
        const clonedTag = { ...exists };
        clonedTag.parentId = tag.parentId;
        this.props
          .dispatch(updateExistedTag({ tag: clonedTag, tempTagId: tag.id }))
          .catch((err) => {
            display(err);
          });
      } else {
        // create a tag
        titles.forEach((title) => {
          const clonedTag = { ...this.props.item };
          clonedTag.text = title;
          if (clonedTag.parentId === 0) {
            clonedTag.parentId = null;
          }
          if (clonedTag.text.length > 0) {
            this.props
              .dispatch(
                createATag({
                  tag: clonedTag,
                  providerId: this.props.providerId,
                })
              )
              .catch((err) => {
                display(err);
              });
          }
        });
      }
    }
  }

  handleCancelSubmitTag(mode) {
    if (mode === 'create') {
      const providerId = this.props.providerId;
      const tagId = this.props.item.id;
      this.props.dispatch(removeTag({ providerId: providerId, tagId: tagId }));
    } else {
      this.setState({ rename: false });
    }
  }

  handleShowDropdown = (showDropdown) => {
    this.setState({ showDropdown });
  };

  render() {
    const { item, selected, readOnly } = this.props;
    if (item.status === 'creating') {
      return (
        <TagEditor
          mode="create"
          item={item}
          isTagExists={this.props.isTagExists}
          onCancel={this.handleCancelSubmitTag}
          onSubmitForm={this.handleSubmitTag}
        />
      );
    } else if (item.status === undefined || item.status === 'exists') {
      if (this.state.rename) {
        return (
          <TagEditor
            mode="update"
            item={item}
            isTagExists={this.props.isTagExists}
            onCancel={this.handleCancelSubmitTag}
            onSubmitForm={this.handleSubmitTag}
          />
        );
      }

      const menuActions = !readOnly ? this.getMenuActions(item) : undefined;
      return (
        <div>
          <li
            className={
              'hover-area collection-item avatar valign-wrapper clickable'
            }
            style={{ background: !selected ? lightGray : 'none' }}
            onClick={this.onOpenFunction(item)}
          >
            <span className="collection-item-content">
              <div className="full-width valign">
                {item.type === 'Identification' && (
                  <Icon type="list" style={{ margin: '10px' }} />
                )}
                {item.universal && (
                  <Icon type="globe" style={{ margin: '10px' }} />
                )}
                <TagText deleted={item.deleted} className="title">
                  {item.text}
                </TagText>
              </div>
            </span>
            <span
              className={
                rightLanguageList.includes(i18n.language)
                  ? 'left-arrow-container'
                  : 'right-arrow-container'
              }
            >
              <span className={'left-arrow'}>
                <ul>
                  <li className="visible-on-hover">
                    <div
                      style={{
                        width: '48px',
                        height: '100%',
                        overflow: 'hidden',
                      }}
                    >
                      {typeof menuActions === 'object' && (
                        <Dropdown
                          marginToTarget={0}
                          placement="bottom-start"
                          target={
                            <MoreSpan className="blue-text left">
                              <Icon type="more-horizontal" />
                            </MoreSpan>
                          }
                          onShowChange={this.handleShowDropdown}
                          show={this.state.showDropdown}
                        >
                          <Menu>
                            {typeof menuActions === 'object'
                              ? menuActions
                                  .sort((a, b) => a.order - b.order)
                                  .map((element, index) => {
                                    if (element.type === 'divider') {
                                      return <MenuDivider key={index} />;
                                    }
                                    return (
                                      <MenuItem key={element.messages}>
                                        <ActionLink
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleShowDropdown(false);
                                            element.callBack();
                                          }}
                                        >
                                          {element.messages}
                                        </ActionLink>
                                      </MenuItem>
                                    );
                                  })
                              : null}
                          </Menu>
                        </Dropdown>
                      )}
                    </div>
                  </li>
                  <li>
                    <Icon type="chevron-left" />
                  </li>
                </ul>
              </span>
            </span>
          </li>
        </div>
      );
    }
  }
}

TagView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isTagExists: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  listIndex: PropTypes.number.isRequired,
  onMoveItem: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onRestoreItem: PropTypes.func.isRequired,
  onOpenItem: PropTypes.func.isRequired,
  providerId: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
};

TagView.defaultProps = {
  selected: true,
};

export default TagView;
